import QuestionHeader from "../component/QuestionHeader";
import QuestionFooter from "../component/QuestionFooter";
import {useEffect, useState} from "react";
import AudioRecorder from "../../../../components/AudioRecorder";
import {useParams} from "react-router-dom";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import "react-circular-progressbar/dist/styles.css";
import {AnswerEmptyDropDown} from "../component/AnswerDropDown";
import useForm from "../../../../hooks/useForm";
import URLS from "../../../../API/Axios/URLS";
import FormNoneFieldErrors from "../../../../components/Form/FormNoneFieldErrors";
import {tokenizeSentence} from "../../../../utils/utils";
import GenericQuestionModal from "../Modal/GenericQuestionModal/GenricQuestionModal";
import {BASE_URL} from "../../../../settings/settings";


export default function ReadAloud({className, ...props}) {
    const {id} = useParams()
    const {question, questionActions} = useQuestion()
    useEffect(() => {
        questionActions.loadQuestions(id)
    }, [])

    // my code
    const [showModal, setShowModal] = useState(false)
    const [response, setResponse] = useState({})
    const [form, error, loading, setFormData, actions] = useForm({
        questionId: id,
        answer: "",
        time: 0,
        answerUrl: ""
    },true)




    async function submitAnswer() {
        if (form?.time < 3) {
            actions.setError({
                non_field_errors: ["Recording should be at least 3 seconds"]
            })
            return
        }
        let answerText = await questionActions.convertBlobToText(form?.answer)
        let text = answerText.data
        if (tokenizeSentence(text).length < tokenizeSentence(question?.transcript).length-4) {
            actions.setError({
                non_field_errors: [`Answer should be at least ${tokenizeSentence(question?.transcript).length}  words`]
            })
            return
        }
       let answerUrl =BASE_URL.replace(/\/$/, "")+ answerText?.audioUrl
        actions.post(URLS.genericQuestionView, (data) => {
            return {
                ...data,
                answer: text,
                answerUrl: answerUrl
            }
        }).then(response => {
            setResponse(response?.data)
            setShowModal(true)
        })


    }

    return (
        <div className={`rounded-lg shadow-lg p-4 ${className}`}>
            <QuestionHeader  {...question}
                             timeLimit={question?.timeLimit && question?.timeLimit + 5000}

            />
            <GenericQuestionModal
                result={response}
                showModal={showModal} setShowModal={setShowModal}/>


            <div className={" flex flex-col items-center md:flex-row p-2 py-8 justify-center gap-8"}>
                <div className={"flex flex-1 px-8 flex-col justify-center gap-4"}>
                    <p className={"text-bawa font-bold mb-3 text-center"}>{question?.transcript}</p>
                    <AudioRecorder
                        setAnswer={(data) => {
                            setFormData({
                                answer: data,
                                time: Math.round(data.duration)
                            })
                        }}
                        answer={form?.answer}
                    />

                    {
                        form?.answer &&
                        <audio
                            onLoadedMetadata={(e) => {
                                console.log(e)
                            }}
                            className={"bg-white self-center rounded-full"} controls src={form?.answer.audioUrl}/>


                    }

                    <FormNoneFieldErrors errors={error?.answer || error?.non_field_errors || error?.time}/>


                </div>


            </div>
            <QuestionFooter
                className={"mx-4 my-2"}
                loading={loading }
                onClickSubmit={submitAnswer}/>
            <div className={"flex flex-1 flex-col overflow-hidden"}>


                <AnswerEmptyDropDown
                    className={" mt-4 "}
                    headerTitle={"Show Answer"}
                >

                    <audio


                        className={"bg-white rounded-full"} controls src={question?.answerUrl}/>

                </AnswerEmptyDropDown>


            </div>

        </div>

    )
}
